export enum EventSurface {
    Asphalt = 1,
    Rubble = 2,
    Concrete = 3,
    Mud = 4,
    Carpet = 5,
    Gravel = 6,
}